import { EMPTY_URL } from "csi/constants";
import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import CustomViewCompositeStore, { CustomViewCompositeViewItem } from "csi/middleware/customView/composite/CustomViewCompositeStore";
import { ICustomViewDataSheetOptions } from "csi/middleware/customView/options/CustomViewOptions";
import { TYPE_VIEW } from "csi/reflection/reflectionConstants";
import { getNodeNames } from "csi/service/nodeService";
import { cnl } from "csi/typings";
import CustomViewController from "csi/view/CustomViewController";
import { ILocaleProvider } from "designSystem/locale";
import { ComponentItem } from "designSystem/types/component-item-types";
import declare from "dojo/_base/declare";
import { DataSheetWidget } from "./Widget";

const DataSheetCustomViewController = declare(CustomViewController, {
	/**
	 * @override
	 * Populate the composite view store for datasheet views
	 */
	async onCreateStore(loc: ILocaleProvider, store: CustomViewDialogStore): Promise<void> {
		const dataSheetWidget = this.widget as DataSheetWidget;
		const nestedViewStore = dataSheetWidget.getNestedViewStore();
		const formattedCustomOptions = dataSheetWidget.getModifiedCustomViewValues();
		const { nestedViews } = formattedCustomOptions as ICustomViewDataSheetOptions;
		const OOTBNestedViewMap = dataSheetWidget.getNestedViewsValue(nestedViewStore);
		const targetNestedViews = nestedViews || OOTBNestedViewMap;
		const urlsToRetrieveName = [];

		Array.from(nestedViewStore.query({}), (item) => {
			const customViewID = item.id;
			const customViewUrl = targetNestedViews[customViewID];
			if (customViewUrl && customViewUrl !== EMPTY_URL) {
				urlsToRetrieveName.push(customViewUrl);
			}
		});

		const nameMap = await getNodeNames(urlsToRetrieveName, TYPE_VIEW);
		nameMap.set(EMPTY_URL, loc.resource("ViewDefault"));

		const customViews: Map<cnl, ComponentItem> = new Map();

		for (const [id, name] of nameMap.entries()) {
			customViews.set(id, { id, name });
		}

		const compositeViewItems: CustomViewCompositeViewItem[] = Array.from(nestedViewStore.query({}), (item) => {
			const customViewID = item.id;
			const customViewUrl = targetNestedViews[customViewID];
			const visible = !!customViewUrl;

			// set to default if no selected option found
			const selectedCustomViewURL = customViewUrl ?? EMPTY_URL;
			const selectedCustomView = customViews.get(selectedCustomViewURL);

			return new CustomViewCompositeViewItem(item, visible, selectedCustomView);
		});

		store.compositeViewStore = new CustomViewCompositeStore(compositeViewItems, store, OOTBNestedViewMap);
	},
});

export = DataSheetCustomViewController;